import { useRef, useState } from 'react'
import { formatearPeso } from '../../utils/formato'

const SWIPE_THRESHOLD = -72

export default function ListaInventario({ productos, onEditar, onEliminar }) {
  if (productos.length === 0) {
    return (
      <div className="text-center py-16 text-tienda-muted">
        <p className="text-5xl mb-4">📦</p>
        <p className="text-xl font-medium">Sin productos</p>
        <p className="text-sm mt-1">Toca "+ Nuevo" para agregar</p>
      </div>
    )
  }

  return (
    <div className="space-y-2 p-4">
      {productos.map(producto => (
        <ProductoCard
          key={producto._id}
          producto={producto}
          onEditar={onEditar}
          onEliminar={onEliminar}
        />
      ))}
    </div>
  )
}

function ProductoCard({ producto, onEditar, onEliminar }) {
  const [offset, setOffset] = useState(0)
  const [abierto, setAbierto] = useState(false)
  const startXRef = useRef(0)
  const startYRef = useRef(0)
  const moviendoRef = useRef(false)

  const sinStock = typeof producto.stock === 'number' && producto.stock <= 0
  const stockBajo = typeof producto.stock === 'number' && producto.stock > 0 && producto.stock <= 5

  function onTouchStart(e) {
    startXRef.current = e.touches[0].clientX
    startYRef.current = e.touches[0].clientY
    moviendoRef.current = false
  }

  function onTouchMove(e) {
    const dx = e.touches[0].clientX - startXRef.current
    const dy = e.touches[0].clientY - startYRef.current

    // Si el scroll vertical es dominante, no interferir
    if (!moviendoRef.current && Math.abs(dy) > Math.abs(dx)) return

    moviendoRef.current = true
    e.preventDefault()

    const base = abierto ? SWIPE_THRESHOLD : 0
    const next = Math.min(0, Math.max(-90, base + dx))
    setOffset(next)
  }

  function onTouchEnd() {
    if (!moviendoRef.current) return
    if (offset < SWIPE_THRESHOLD / 2) {
      setOffset(SWIPE_THRESHOLD)
      setAbierto(true)
    } else {
      setOffset(0)
      setAbierto(false)
    }
  }

  function cerrar() {
    setOffset(0)
    setAbierto(false)
  }

  function handleTap() {
    if (abierto) {
      cerrar()
    } else {
      onEditar(producto)
    }
  }

  return (
    <div className="relative overflow-hidden rounded-2xl">
      {/* Fondo rojo de borrar */}
      <div className="absolute inset-0 flex items-center justify-end bg-tienda-danger rounded-2xl">
        <button
          onClick={() => { cerrar(); onEliminar(producto) }}
          className="w-20 h-full flex flex-col items-center justify-center gap-1 text-white active:brightness-90"
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
            <path d="M10 11v6M14 11v6" />
            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
          </svg>
          <span className="text-xs font-bold">Borrar</span>
        </button>
      </div>

      {/* Tarjeta deslizable */}
      <div
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onClick={handleTap}
        style={{
          transform: `translateX(${offset}px)`,
          transition: moviendoRef.current ? 'none' : 'transform 0.2s ease',
        }}
        className="card p-4 flex items-center gap-3 relative z-10 cursor-pointer active:brightness-90"
      >
        <div className="w-12 h-12 rounded-xl bg-tienda-bg flex items-center justify-center text-2xl flex-shrink-0">
          {producto.emoji || producto.nombre.charAt(0).toUpperCase()}
        </div>

        <div className="flex-1 min-w-0">
          <p className="font-semibold text-tienda-text truncate">{producto.nombre}</p>
          <div className="flex items-center gap-2 mt-0.5 flex-wrap">
            <span className="text-tienda-accent font-bold">{formatearPeso(producto.precio)}</span>
            {producto.stock != null && (
              <span className={`text-xs font-semibold px-2 py-0.5 rounded-full
                ${sinStock
                  ? 'bg-tienda-danger/20 text-tienda-danger'
                  : stockBajo
                  ? 'bg-tienda-accent/20 text-tienda-accent'
                  : 'bg-tienda-success/20 text-tienda-success'}`
              }>
                {sinStock ? 'Agotado' : `Stock: ${producto.stock}`}
              </span>
            )}
          </div>
        </div>

        {/* Hint de swipe */}
        <svg className="w-4 h-4 text-tienda-border flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </div>
    </div>
  )
}
